import { axios } from '../plugins/axios';

export default {
  namespaced: true,
  state: {
    comprobantesEstudios: [],
  },

  getters: {
    getComprobantesEstudios: (state) => state.comprobantesEstudios,
  },

  mutations: {
    SET_COMPROBANTES_ESTUDIOS(state, comprobantesEstudios) {
      state.comprobantesEstudios = comprobantesEstudios;
    },
  },

  actions: {
    async fetchComprobantesEstudios({ commit }) {
      await axios
        .get('PoliciaCuadrantes/EstadoFuerza/comprobanteEstudios')
        .then((response) => {
          commit('SET_COMPROBANTES_ESTUDIOS', response.data.data);
        });
    },
  },
};
